import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import moment from 'moment';

class PreguiReporte extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: '', saveUrl: '', backUrl: '' },
      new Form([
        Form.Field('date', 'startDate', 'Fecha Inicial', '', [Validators.required], 6),
        Form.Field('date', 'endDate', 'Fecha Final', '', [Validators.required], 6),
        Form.Field('select', 'type', 'Tipo', '', [Validators.required], 6, [
          { Label: 'Asingadas a Transportistas', Value: '1' },
          { Label: 'Realizadas por Transportistas', Value: '2' },
          { Label: 'Efectuadas pendientes de documentar', Value: '3' },
          { Label: 'Documentadas', Value: '4' },
          { Label: 'Todas las Recolecciones', Value: '5' },
          { Label: 'Confirmadas por Transportista', Value: '6' },
          { Label: 'No confirmadas por Transportista', Value: '7' },
        ]),
      ], ['Descargar Excel'], 'Reporte Preguias'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    const { startDate, endDate, type } = vals;
    const start = moment(startDate).format('YYYY-MM-DD')
    const end = moment(endDate).format('YYYY-MM-DD')
    const Resp = await Http.get(`preguia/reporte?q=1&start_date=${start}&end_date=${end}&type=${type}`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte_preguia_${start}-${end}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
    this.setState({ loading: false });
  }

  render() {
    return (
      <div>
        <this.FormRender on />
      </div>
    )
  }
}

export default withRouter(PreguiReporte)
